<template>
  <div
:id="id"
class="m-2 data-table-toolbar"
>
    <b-row>
      <b-col
cols="12"
md="4"
>
        <label :for="`${id}-branch`">Branch</label>
        <v-select-new
          :input-id="`${id}-branch`"
          :value="branch"
          :options="branches"
          @input="$emit('update:branch', $event)"
        />
      </b-col>
      <b-col
cols="12"
md="4"
>
        <label :for="`${id}-asset-group`">Asset Group</label>
        <v-select-new
          :input-id="`${id}-asset-group`"
          :value="assetGroup"
          :options="assetGroups"
          @input="$emit('update:asset-group', $event)"
        />
      </b-col>
      <b-col
cols="12"
md="4"
>
        <label :for="`${id}-asset-status`">Asset Status (New/Old)</label>
        <v-select-new
          :input-id="`${id}-asset-status`"
          :value="assetStatus"
          :options="assetStatusOptions"
          placeholder="All Assets"
          @input="$emit('update:asset-status', $event)"
        />
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col
cols="12"
md="4"
>
        <label :for="`${id}-start-date`">Tanggal Awal</label>
        <b-form-datepicker
          :id="`${id}-start-date`"
          :value="startDate"
          class="mb-2"
          @input="$emit('update:start-date', $event)"
        />
      </b-col>
      <b-col
cols="12"
md="4"
>
        <label :for="`${id}-end-date`">Tanggal Akhir</label>
        <b-form-datepicker
          :id="`${id}-end-date`"
          :value="endDate"
          class="mb-2"
          @input="$emit('update:end-date', $event)"
        />
      </b-col>
      <b-col
cols="12"
md="4"
class="d-flex align-items-center justify-content-center"
>
        <div class="data-table-toolbar__exports">
          <b-button
            :id="`${id}-btn-excel`"
            variant="primary"
            class="data-table-toolbar__export-btn"
            :disabled="isLoadingExcel"
            @click="$emit('export-excel')"
          >
            <feather-icon icon="DownloadIcon" /> Excel
            <b-spinner
v-if="isLoadingExcel"
small
type="grow"
/>
          </b-button>
          <b-button
            :id="`${id}-btn-pdf`"
            variant="danger"
            class="data-table-toolbar__export-btn"
            :disabled="isLoadingPdf"
            @click="$emit('export-pdf')"
          >
            <feather-icon icon="FileTextIcon" /> PDF
            <b-spinner
v-if="isLoadingPdf"
small
type="grow"
/>
          </b-button>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="12"
        md="6"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <label :for="`${id}-per-page`">Show</label>
        <v-select-new
          :input-id="`${id}-per-page`"
          :value="perPage"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="perPageOptions"
          :clearable="false"
          class="per-page-selector d-inline-block mx-50"
          @input="$emit('update:per-page', $event)"
        />
        <label>entries</label>
      </b-col>
      <b-col
cols="12"
md="6"
>
        <div class="d-flex align-items-center justify-content-end">
          <b-form-input
            :id="`${id}-search`"
            :value="searchQuery"
            class="d-inline-block mr-1"
            placeholder="Search..."
            @input="$emit('update:search-query', $event)"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormInput, BButton, BSpinner, BFormDatepicker,
} from 'bootstrap-vue'
import vSelectNew from 'vue-select'

export default {
  name: 'DataTableToolbar',
  components: {
    BRow,
    BCol,
    BFormInput,
    BButton,
    BSpinner,
    BFormDatepicker,
    vSelectNew,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    branch: {
      type: [Object, String, Number],
      default: null,
    },
    assetGroup: {
      type: [Object, String, Number],
      default: null,
    },
    assetStatus: {
      type: [Object, String, Number],
      default: null,
    },
    startDate: {
      type: String,
      default: '',
    },
    endDate: {
      type: String,
      default: '',
    },
    perPage: {
      type: Number,
      default: 10,
    },
    searchQuery: {
      type: String,
      default: '',
    },
    branches: {
      type: Array,
      default: () => [],
    },
    assetGroups: {
      type: Array,
      default: () => [],
    },
    assetStatusOptions: {
      type: Array,
      default: () => [],
    },
    perPageOptions: {
      type: Array,
      default: () => [10, 25, 50, 100],
    },
    isLoadingExcel: {
      type: Boolean,
      default: false,
    },
    isLoadingPdf: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

// The Excel/PDF export buttons used to sit in a `<b-button-group vertical>`,
// which is designed to make adjacent buttons look like one fused control
// (shared edges, square corners where they touch) - fine for something like
// pagination, wrong for two unrelated actions that just happened to be
// stacked here. That's the "dempet"/cramped look: no gap, flat seam between
// a teal and a red button. This gives each button its own full rounded
// shape with breathing room between them, and lays them out in a row with
// wrapping so they don't get squeezed on narrow/mobile widths either.
.data-table-toolbar__exports {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  width: 100%;
  justify-content: center;
}

.data-table-toolbar__export-btn {
  flex: 1 1 auto;
  min-width: 120px;
  border-radius: 10px !important;
}

@media (max-width: 767.98px) {
  .data-table-toolbar__exports {
    flex-direction: column;
  }

  .data-table-toolbar__export-btn {
    width: 100%;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>